import { createFileRoute } from '@tanstack/react-router';

import { SyncBibtex } from '@/module/Sync/SyncBibtex';

export const Route = createFileRoute('/_auth/sync-bibtex')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sync.bibtex.title' },
  },
});

function RouteComponent() {
  return <SyncBibtex />;
}
